import { QRCodeSVG } from "qrcode.react";

export const WAITLIST_URL = "https://marova.com/waitlist";

export default function EndCard() {
  return (
    <div className="still grain" data-testid="still-end_card" style={{ width: 1080, height: 1920, display: "flex", flexDirection: "column", justifyContent: "center", padding: "0 120px" }}>
      <span className="wordmark" style={{ fontSize: 168, lineHeight: 1 }}>marova</span>
      <div style={{ width: 88, height: 3, background: "var(--burgundy)", marginTop: 56 }} />
      <div className="serif" style={{ fontSize: 96, fontWeight: 500, lineHeight: 1.05, marginTop: 64, letterSpacing: "-0.01em" }}>
        Your evening,<br />handled.
      </div>
      <div style={{ fontSize: 36, lineHeight: 1.5, color: "var(--ink-60)", marginTop: 40, maxWidth: 720 }}>
        One request. Every service. Confirmed — without the back-and-forth.
      </div>
      <div style={{ marginTop: 110, display: "flex", alignItems: "center", gap: 48 }}>
        <div>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 26, background: "var(--burgundy)", color: "var(--porcelain)", borderRadius: 999, padding: "34px 60px", fontSize: 36, fontWeight: 600 }}>
            Join the waitlist
            <span style={{ fontSize: 40, lineHeight: 1 }}>→</span>
          </div>
          <div style={{ marginTop: 30, fontSize: 30, color: "var(--charcoal)", fontWeight: 500 }}>marova.com/waitlist</div>
        </div>
        <div data-testid="end-card-qr" style={{ background: "#fff", padding: 22, borderRadius: 28, border: "1px solid var(--ink-12)", display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
          <QRCodeSVG value={WAITLIST_URL} size={196} bgColor="#ffffff" fgColor="#1F1F1F" level="M" />
          <span style={{ fontSize: 20, letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--ink-60)", fontWeight: 600 }}>scan to join</span>
        </div>
      </div>

      <div style={{ position: "absolute", left: 120, right: 120, bottom: 140, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div style={{ fontSize: 28, letterSpacing: "0.18em", textTransform: "uppercase", color: "var(--burgundy)", fontWeight: 600 }}>Launching first in San Diego · 2026</div>
        <div style={{ width: 14, height: 14, borderRadius: "50%", background: "var(--burgundy)", opacity: .5 }} />
      </div>
    </div>
  );
}
